import React from 'react'
import classNames from 'classnames'
import { IconButton } from '@chakra-ui/react'
import { IconBell } from '_base/Icon'

function AppNotificationButton({ notifications, unread, ...rest }) {
  return (
    <IconButton
      variant="ghost"
      aria-label="Notifications"
      borderRadius="full"
      pos="relative"
      size="md"
      minW="32px"
      w="32px"
      className={classNames('app-notification-button', {
        unread: unread.length > 0
      })}
      {...rest}
      icon={<IconBell fontSize="15px" />}
    />
  )
}
export default AppNotificationButton
